export const APP_MODULE_TYPE_ACTION = 'ACTION'
export const APP_MODULE_TYPE_SEARCH = 'SEARCH'
export const APP_MODULE_TYPE_UNIVERSAL = 'UNIVERSAL'
export const APP_MODULE_TYPE_INSTANT_TRIGGER = 'INSTANT_TRIGGER'
export const APP_MODULE_TYPE_RESPONDER = 'RESPONDER'
export const APP_MODULE_TYPE_TRIGGER = 'TRIGGER'

export const APP_MODULE_ACTION_READ = 'Read'
export const APP_MODULE_ACTION_CREATE = 'Create'
export const APP_MODULE_ACTION_UPDATE = 'Update'
export const APP_MODULE_ACTION_DELETE = 'Delete'

export const appModuleTypes = Object.freeze({
    [APP_MODULE_TYPE_ACTION]: {
        key: APP_MODULE_TYPE_ACTION,
        label: 'Action'
    },
    [APP_MODULE_TYPE_SEARCH]: {
        key: APP_MODULE_TYPE_SEARCH,
        label: 'Search'
    },
    [APP_MODULE_TYPE_UNIVERSAL]: {
        key: APP_MODULE_TYPE_UNIVERSAL,
        label: 'Universal'
    },
    [APP_MODULE_TYPE_INSTANT_TRIGGER]: {
        key: APP_MODULE_TYPE_INSTANT_TRIGGER,
        label: 'Instant trigger'
    },
    [APP_MODULE_TYPE_RESPONDER]: {
        key: APP_MODULE_TYPE_RESPONDER,
        label: 'Responder'
    },
    [APP_MODULE_TYPE_TRIGGER]: {
        key: APP_MODULE_TYPE_TRIGGER,
        label: 'Trigger'
    }
})

export const appModuleActions = Object.freeze([APP_MODULE_ACTION_READ, APP_MODULE_ACTION_CREATE, APP_MODULE_ACTION_UPDATE, APP_MODULE_ACTION_DELETE])

export const appModuleTypesList = Object.freeze(Object.values(appModuleTypes))
